<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
				<div class="card">
					<div class="card-header bg-info text-white">
						Selecciona un permiso
					</div>
					<table class="m-0 table table-condensed table-striped" v-for="modulo in listadoPermisos" :key="modulo.nombre">
						<thead :class="(mod === modulo.nombre) ? 'bg-dark text-white' : 'bg-light'">
							<tr @click="cambiaModulo(modulo)" style="cursor:pointer;">
								<th style="width:30px;">
									<span class="fa fa-gear"></span>
								</th>
								<th>
									{{modulo.nombre}}
								</th>
							</tr>
						</thead>
						<tbody v-if="mod === modulo.nombre">
							<tr v-for="item in modulo.items" :key="item.permiso" style="cursor:pointer;" @click="getPermiso(item.nombre)">
								<td style="width: 30px;" class="bg-dark text-white">
									<span class="fa fa-lock"></span>
								</td>
								<td :class="(permiso !== null && permiso.nombre === item.nombre) ? 'bg-info text-white' : ''">
									{{item.descripcion}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" v-if="permiso !== null">
				<div class="card">
					<div class="card-header bg-danger text-white">
						Detalles del permiso
					</div>
					<div class="card-body bg-light">
						<h4>
							<b>{{mod}}</b>
							<br>
							<small>{{permiso.descripcion}}</small>
						</h4>
					</div>
					<div class="card-body row">
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<b>Permiso por grupos</b>
							<input-query input-class="form-control" class="form-control p-0" placeholder="Busca y añade un grupo" url="gestion-permisos/php/buscaGrupos.php" :realtime="true" @selected="ponGrupo($event)"></input-query>
							<table class="table table-condensed table-striped mt-2">
								<tbody>
									<tr v-for="(grupo, index) in permiso.grupos" :key="grupo.grupo_ID">
										<td style="width:30px;">
											<span class="fa fa-users"></span>
										</td>
										<td>
											{{grupo.nombre}}
										</td>
										<td style="width:120px;text-align:right;">
											<div class="btn-group">
												<button class="btn btn-sm" :class="(grupo.permitido) ? 'btn-success' : 'btn-light'" @click="grupo.permitido = true">
													<span class="fa fa-check"></span>
												</button>
												<button class="btn btn-sm" :class="(grupo.permitido) ? 'btn-light' : 'btn-danger'" @click="grupo.permitido = false">
													<span class="fa fa-ban"></span>
												</button>
											</div>
											<button class="ml-2 btn btn-sm btn-warning" @click="permiso.grupos.splice(index, 1)">
												<span class="fa fa-trash"></span>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<b>Permiso por usuarios</b>
							<input-query input-class="form-control" class="form-control p-0" placeholder="Busca y añade un usuario" url="gestion-permisos/php/buscaUsuarios.php" :realtime="true" @selected="ponUsuario($event)"></input-query>

							<table class="table table-condensed table-striped mt-2">
								<tbody>
									<tr v-for="(usuario, index) in permiso.usuarios" :key="usuario.grupo_ID">
										<td style="width:30px;">
											<span class="fa fa-user"></span>
										</td>
										<td>
											{{usuario.nombre}} {{usuario.apellidos}}
										</td>
										<td style="width:120px;text-align:right;">
											<div class="btn-group">
												<button class="btn btn-sm" :class="(usuario.permitido) ? 'btn-success' : 'btn-light'" @click="usuario.permitido = true">
													<span class="fa fa-check"></span>
												</button>
												<button class="btn btn-sm" :class="(usuario.permitido) ? 'btn-light' : 'btn-danger'" @click="usuario.permitido = false">
													<span class="fa fa-ban"></span>
												</button>
											</div>
											<button class="ml-2 btn btn-sm btn-warning" @click="permiso.usuarios.splice(index, 1)">
												<span class="fa fa-trash"></span>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-sm btn-primary" @click="guardar()">
							<span class="fa fa-save mr-2"></span>
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	data () {
		return {
			mod: null,
			permiso: null,
			listadoPermisos: []
		}
	},

	created () {
		this.getPermisos()
	},

	methods: {
		getPermisos () {
			axios.get('gestion-permisos/php/getPermisos.php')
				.then(res => {
					this.listadoPermisos = res.data.permisos
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getPermiso (permiso) {
			axios.get('gestion-permisos/php/getPermiso.php?permiso=' + permiso)
				.then(res => {
					this.permiso = res.data.permiso
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cambiaModulo (modulo) {
			this.mod = modulo.nombre
			this.permiso = null
		},

		ponGrupo (ev) {
			for (let i = 0; i < this.permiso.grupos.length; i++) {
				if (this.permiso.grupos[i].grupo_ID === ev.datos.ID_grupo) {
					return
				}
			}
			this.permiso.grupos.push({
				grupo_ID: ev.datos.ID_grupo,
				nombre: ev.datos.nombre,
				permitido: false
			})
		},

		ponUsuario (ev) {
			for (let i = 0; i < this.permiso.usuarios.length; i++) {
				if (this.permiso.usuarios[i].usuario_ID === ev.datos.ID) {
					return
				}
			}
			this.permiso.usuarios.push({
				usuario_ID: ev.datos.ID,
				nombre: ev.datos.nombre,
				apellidos: ev.datos.apellidos,
				permitido: false
			})
		},

		guardar () {
			axios.post('gestion-permisos/php/setPermiso.php', this.permiso)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Permiso guardado'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>

<style scoped>
	.moduloItem {
		position: relative;
		display: table-cell;
		vertical-align: middle;
		padding: 10px;
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-permisos/vue/App.vue